// ================================
//  API Configuration Constants (Cinevestor Live)
// ================================

/**
 * On the live server, we use a relative path "/api".
 * This tells the browser to stay on https://contributor.cinevestor.in 
 * and let Nginx route the request to the backend.
 */
const configuredApiUrl = process.env.REACT_APP_API_URL;

export const BASE_API_URL = configuredApiUrl && configuredApiUrl.trim() !== ""
    ? configuredApiUrl
    : "/api";

// Maintaining compatibility for your existing components

export const LOCAL_API_URL = BASE_API_URL;
export const SERVER_API_URL = BASE_API_URL;

export const LOCAL_HOST = "";
export const LOCAL_PORT = "";
export const SERVER_HOST = "";
export const SERVER_PORT = "";